import { useTranslation } from 'react-i18next';
import "./translation-style.scss"
import { Typography, TypographyProps } from '@mui/material';

interface ITranslate extends TypographyProps {
    prefix?: string;
    text: string;
    suffix?: string;
}

const Translate = ({ prefix, text, suffix, ...typoProps }: ITranslate) => {
    const { t } = useTranslation();

    return (
        <Typography {...typoProps}>
            {prefix && `${prefix} `}
            {t(text)}
            {suffix && ` ${suffix}`}
        </Typography >
    )
}

export default Translate;
